'use strict';

let winWidth = window.innerWidth;
let breakPointMedium = 960;
let resizeTimer;
// let flckBottom;

// slideUp
const slideUp = (el, duration = 300) => {
  el.style.height = el.offsetHeight + "px";
  el.offsetHeight;
  el.style.transitionProperty = "height, margin, padding";
  el.style.transitionDuration = duration + "ms";
  el.style.transitionTimingFunction = "ease";
  el.style.overflow = "hidden";
  el.style.height = 0;
  el.style.paddingTop = 0;
  el.style.paddingBottom = 0;
  el.style.marginTop = 0;
  el.style.marginBottom = 0;
  setTimeout(() => {
    el.style.display = "none";
    el.style.removeProperty("height");
    el.style.removeProperty("padding-top");
    el.style.removeProperty("padding-bottom");
    el.style.removeProperty("margin-top");
    el.style.removeProperty("margin-bottom");
    el.style.removeProperty("overflow");
    el.style.removeProperty("transition-duration");
    el.style.removeProperty("transition-property");
    el.style.removeProperty("transition-timing-function");
  }, duration);
};

// slideDown
const slideDown = (el, duration = 300) => {
  el.style.removeProperty("display");
  let display = window.getComputedStyle(el).display;
  if (display === "none") {
    display = "block";
  }
  el.style.display = display;
  let height = el.offsetHeight;
  el.style.overflow = "hidden";
  el.style.height = 0;
  el.style.paddingTop = 0;
  el.style.paddingBottom = 0;
  el.style.marginTop = 0;
  el.style.marginBottom = 0;
  el.offsetHeight;
  el.style.transitionProperty = "height, margin, padding";
  el.style.transitionDuration = duration + "ms";
  el.style.transitionTimingFunction = "ease";
  el.style.height = height + "px";
  el.style.removeProperty("padding-top");
  el.style.removeProperty("padding-bottom");
  el.style.removeProperty("margin-top");
  el.style.removeProperty("margin-bottom");
  setTimeout(() => {
    el.style.removeProperty("height");
    el.style.removeProperty("overflow");
    el.style.removeProperty("transition-duration");
    el.style.removeProperty("transition-property");
    el.style.removeProperty("transition-timing-function");
  }, duration);
};

// slideToggle
const slideToggle = (el, duration = 300) => {
  if (window.getComputedStyle(el).display === "none") {
    return slideDown(el, duration);
  } else {
    return slideUp(el, duration);
  }
};


document.addEventListener('DOMContentLoaded', () => {

  // 下層、ナビ
  const lowerNav = document.querySelector('.l-lower__nav');

  if(lowerNav !== null){
    // アコーディオンボタン
    const naviAccordionBtn2 = document.querySelectorAll('.js-accordion__trigger--category2');
    const naviAccordionBtn3 = document.querySelectorAll('.js-accordion__trigger--category3');

    // アコーディオンイベント
    naviAccordionBtn2.forEach((target, index) => {
      target.addEventListener('click', (e) => {
        e.preventDefault();

        // 開閉
        const el = document.querySelectorAll('.js-accordion__container--category2')[index];
        slideToggle(el, 300);

        // toggleClass
        const targetParent = target.parentNode;
        targetParent.classList.toggle('is__open');
      });
    })

    // アコーディオンイベント
    naviAccordionBtn3.forEach((target, index) => {
      target.addEventListener('click', (e) => {
        e.preventDefault();

        // 開閉
        const el = document.querySelectorAll('.js-accordion__container--category3')[index];
        slideToggle(el, 300);

        // toggleClass
        const targetParent = target.parentNode;
        targetParent.classList.toggle('is__open');
      });
    })



  }


  // ハンバーガーメニュー
  if(winWidth <= breakPointMedium){

    // アコーディオンボタン
    const spNavBtn = document.querySelector('.js-sp__nav__button');
    const slideHeaderBtn = document.querySelector('.js-accordion__trigger--header');

    // アコーディオンイベント
    spNavBtn.addEventListener('click', (e) => {
      e.preventDefault();

      // toggleClass
      const body = document.querySelector('body');
      body.classList.toggle('is__nav');
    });

    // アコーディオンイベント
    slideHeaderBtn.addEventListener('click', (e) => {
      e.preventDefault();

      // 開閉
      const el = document.querySelector('.js-accordion__container--header');
      slideToggle(el, 300);

      // toggleClass
      const body = document.querySelector('body');
      body.classList.toggle('is__header');
    });
  }

  const searchClose = document.getElementById('js-searchClose');
  const searchOpen = document.getElementById('js-searchBtn');
  const dialogSearch = document.getElementById('dialog__search');

  try {
    // 検索box 閉
    searchClose.addEventListener('click', () => {
      dialogSearch.classList.remove('open');
    });
    // 検索box 開
    searchOpen.addEventListener('click', () => {
      dialogSearch.classList.add('open');
      const dialogInput = document.querySelector('#dialog__search input');
      window.setTimeout( function() {
        dialogInput.focus();
      }, 100);
    });
  } catch(e) {
    console.log("Err: "+ e.message +" in search-dialog.js");
  }

  const hoverMenu = document.querySelectorAll('.js-hoverMenu');
  hoverMenu.forEach((element) => {
    element.addEventListener('mouseover', () => {
      document.querySelector('header').classList.add('is__open');
    });
    element.addEventListener('mouseleave', () => {
      document.querySelector('header').classList.remove('is__open');
    });
  });

	// 追従メニュー
	let y = window.pageYOffset;
	const header = document.querySelector('.l-header');
	const headerHeight = header.clientHeight;

	window.addEventListener('scroll', () => {
		y = window.pageYOffset;
		if(headerHeight <= y){
			header.classList.add('is__sticky');
		}else{
			header.classList.remove('is__sticky');
		}
	});
});


// cookie制御
function setCookie(name,value,days) {
	let expires = "";
	if (days) {
			let date = new Date();
			date.setTime(date.getTime() + (days*24*60*60*1000));
			expires = "; expires=" + date.toUTCString();
	}
	document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}

function getCookie(name) {
	let nameEQ = name + "=";
	let ca = document.cookie.split(';');
	for(let i=0;i < ca.length;i++) {
			let c = ca[i];
			while (c.charAt(0)==' ') c = c.substring(1,c.length);
			if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
	}
	return null;
}
